const ALLOW_COPY_CLASS = 'allow-copy';

function blockContextMenu(event) {
  event.preventDefault();
}

export function enableCopyProtection() {
  document.removeEventListener('contextmenu', blockContextMenu, true);
  document.addEventListener('contextmenu', blockContextMenu, true);
  document.body.classList.remove(ALLOW_COPY_CLASS);
}

export function disableCopyProtection() {
  document.removeEventListener('contextmenu', blockContextMenu, true);
  document.body.classList.add(ALLOW_COPY_CLASS);
}

export function syncCopyProtection(route) {
  const allow = route.matched.some((record) => record.meta.allowCopy === true);
  if (allow) {
    disableCopyProtection();
  } else {
    enableCopyProtection();
  }
}
